import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
// import { BgImage } from "gbimage-bridge"

// import Header from "./header"
import Menu from "./menuMain"
import BreadCrumbs from "./breadCrumbs"
import Footer from "./footer"
import ButtonOk from "./ButtonOk"
// import Coupons from "./couponsRow"
import ButtonModal from "./modal"

const Layout = ({
  children,
  bg,
  heroH1,
  heroText,
  heroCta,
  buttonLink,
  breadCrumbs,
}) => {
  const data = useStaticQuery(graphql`
    query CompanyQuery {
      datoCmsCompany {
        title
        subtitle
        address
        phone
      }
      datoCmsIndexPage {
        image {
          gatsbyImageData(
            imgixParams: {
              w: "1024"
              auto: "compress,enhance,format"
              q: 85
              # fit: "fillmax"
            }
            placeholder: BLURRED
            width: 1024
            layout: FULL_WIDTH
          )
        }
      }
      datoCmsAsset(
        filename: { eq: "img_6914_facetune_06-07-2020-19-27-03.jpg" }
      ) {
        gatsbyImageData(
          imgixParams: {
            w: "1024"
            auto: "compress,enhance,format"
            q: 85
            # fit: "fillmax"
          }
          placeholder: BLURRED
          width: 1024
          layout: FULL_WIDTH
        )
      }
    }
  `)

  return (
    <div className="bg-gradient-to-r from-slate-900 via-slate-900/60 to-transparent">
      <div className="relative">
        <Menu
          companyTitle={data.datoCmsCompany?.title || `Title`}
          companySubTitle={data.datoCmsCompany?.subtitle || `Subtitle`}
          phone={data.datoCmsCompany?.phone || `Phone`}
          address={data.datoCmsCompany?.address || `Address`}
        />

        <div className="text-white font-opensans max-w-full mx-auto py-24 px-4 sm:px-8 xl:px-24 flex flex-col content-start gap-8">
          <div className="absolute inset-0 -z-10">
            {/* <div className="bg-black opacity-90 w-full h-full" /> */}

            <GatsbyImage
              className="h-full w-full object-cover"
              image={
                bg
                  ? bg.gatsbyImageData
                  : data.datoCmsIndexPage.image.gatsbyImageData
              }
              alt={`${data.datoCmsCompany?.title} photo` || `Title`}
            />
          </div>
          {breadCrumbs && <BreadCrumbs breadCrumbs={breadCrumbs} />}
          <h1 className="text-5xl leading-ok md:text-6xl md:leading-ok font-playfaird font-medium tracking-wide">
            {heroH1}
          </h1>
          {heroText && <p className="text-lg max-w-xl">{heroText}</p>}
          <div>
            {buttonLink ? (
              <ButtonOk buttonLink={buttonLink} buttonText={heroCta} />
            ) : (
              <ButtonModal buttonText={heroCta} />
            )}
          </div>
        </div>
      </div>

      {/* </BgImage> */}

      {children}
      {/* <Coupons /> */}
      <Footer />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
